import React, { useContext, useEffect, useState } from 'react';
import ProviderService from "../../../../../../services/api/provider.service";
import DoctorService from "../../../../../../services/api/doctor.service";
import APIResponse from '../../../../../templates/components/APIResponse';
import { store } from '../../../../../../context/StateProvider';
import DimLoader from '../../../../../templates/components/DimLoader';

const PracticeLocationProvider = (props) => {
    const [isLoader, setIsLoader] = useState(false)
    const [isUpdateNoSelfSchedule, setIsUpdateNoSelfSchedule] = useState(false)
    const [providerList, setProviderList] = useState()
    const [apiResponse,setApiResponse] = useState()
    const globalStateAndDispatch = useContext(store)
    const dispatch = globalStateAndDispatch.dispatch
    
    const onSuccess = (message) => {
        getProviders()
        if(!isUpdateNoSelfSchedule){
            dispatch({
                type: "setLocationProviderServices",
                payload: null
            });
        }
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.onClose) {
            props.onClose()
        }
        setIsUpdateNoSelfSchedule(false)
    }
    const onError = (message) => {
        if(isUpdateNoSelfSchedule){
            setIsUpdateNoSelfSchedule(false)
        }
    }
    const getProviders = () => {
        setIsLoader(true);
        DoctorService.find({isActive: true, isRegistered: true, SortField: 'firstName'})
            .then((resp) => {
                let allProviders = resp.data
                //console.log(allProviders)
                ProviderService.getProvidersForSelectedLocation({
                    PracticeLocationId: props.id,
                }).then(response => {
                    let selectedProviders = response.data
                    //console.log(selectedProviders)
                    selectedProviders.forEach(selectedProvider => {
                        allProviders.forEach(obj => {
                            if (obj.id === selectedProvider.doctorId) {
                                obj.isChecked = true
                                obj.practiceLocationPractitionerId = selectedProvider.practiceLocationPractitionerId
                                obj.noSelfSchedule = selectedProvider.noSelfSchedule
                            }
                        })
                    })
                    setProviderList(allProviders)
                    setIsLoader(false);
                }).catch(error => {
                    setIsLoader(false);
                })
            })
            .catch(error => {
                setIsLoader(false);
            })
    }

    useEffect(() => {
        getProviders();
    }, [props.id]);


const removeProvider = (providerId,practiceLocationPractitionerId) =>{
    setIsLoader(true)
    ProviderService.updateProvidersForSelectedLocation({
        practiceLocationId: props.id,
        doctorId: providerId,
        isDeleted: 1
    }, practiceLocationPractitionerId)
    .then(response => {
        setApiResponse(response)
    })
    .catch(error => {
        setApiResponse(error)
    })
    .finally(() => {
        setIsLoader(false)
    });
}
const updateNoSelfScheduleForProvider = (providerId,practiceLocationPractitionerId,noSelfSchedule) =>{
    setIsLoader(true)
    ProviderService.updateProvidersForSelectedLocation({
        practiceLocationId: props.id,
        doctorId: providerId,
        noSelfSchedule: noSelfSchedule
    }, practiceLocationPractitionerId).then(response => {
        setApiResponse(response)
    })
    .catch(error => {
        setApiResponse(error)
    })
    .finally(() => {
        setIsLoader(false)
    });
}
const addProvider = (providerId) =>{
    setIsLoader(true)
    ProviderService.createProvidersForSelectedLocation({
        practiceLocationId: props.id,
        doctorId: providerId,
    }).then(response => {
        setApiResponse(response)
    })
    .catch(error => {
        setApiResponse(error)
    })
    .finally(() => {
        setIsLoader(false)
    });
}
    return (
        <>
            {isLoader && <DimLoader />}
            <div className='d-flex row'>
                <div className='col-md-8 col-12'>
                    <div className='card'>
                        <div className='card-header'>Active Providers</div>
                        <div className='card-body row d-flex'>
                            {providerList && providerList.filter(obj => obj.isChecked).map((provider,i) => {
                                return (
                                    <div className='col-md-3 col-12' key={i}>
                                        <span title="Remove from Location" className='text-start point' onClick={e => { e.preventDefault(); removeProvider(provider.id,provider.practiceLocationPractitionerId) }}><i className='icon minus small' /> {provider.firstName} {provider.lastName} </span>
                                        <i onClick={e => { e.preventDefault(); setIsUpdateNoSelfSchedule(true); updateNoSelfScheduleForProvider(provider.id,provider.practiceLocationPractitionerId,provider.noSelfSchedule === 0 ? 1 : 0); }} className={provider.noSelfSchedule ? 'icon calendar times' : 'icon calendar check'} title={provider.noSelfSchedule ? "Not available for self-scheduling" : "Available for self-scheduling"} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className='col-md-4 col-12'>
                    <div className='card'>
                        <div className='card-header'>Inactive Providers</div>
                        <div className='card-body row d-flex'>
                            {providerList && providerList.filter(obj => !obj.isChecked).map((provider,i) => {
                                return (
                                    <div className='col-md-6 col-12' key={i}>
                                        <span title="Add to Location" className='text-start point' onClick={e => { e.preventDefault(); addProvider(provider.id) }}><i className='icon plus small' /> {provider.firstName} {provider.lastName}</span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} onError={onError}/>
        </>
    )
}

export default PracticeLocationProvider;